import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { PropsWithChildren, ReactNode } from "react";

interface DialogProps {
  trigger: ReactNode;
  title: string | ReactNode | ReactNode[] | string[];
  description?: string | ReactNode | ReactNode[] | string[];
  subDescription?: string | ReactNode | ReactNode[] | string[];
  className?: string;
}

const DialogDemo = ({ ...props }: PropsWithChildren<DialogProps>) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{props.trigger}</DialogTrigger>
      <DialogContent className={props.className}>
        <DialogHeader>
          <DialogTitle>{props.title}</DialogTitle>
          {props.description && (
            <DialogDescription>{props.description}</DialogDescription>
          )}
          {props.subDescription && (
            <DialogDescription>{props.subDescription}</DialogDescription>
          )}
        </DialogHeader>

        {props.children}
      </DialogContent>
    </Dialog>
  );
};

export default DialogDemo;
